import {lazy} from 'react';

const StoreManagementList = lazy(() => import('./StoreManagementList'));

export default StoreManagementList;
